import config from '../data/config.json';
import dict from '../data/dictionary.json';

import Mustache from 'mustache';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import noUiSlider from 'nouislider';

import { Sesion, Datos, cargarURL, obtenerURL } from '../main.js';
import { filtroTaxonesTemplate, coloresTemplate, taxonesSubheadingTemplate, sugeTaxonesTemplate, 
	taxonesBlockTemplate, taxonModalTemplate, filterPlotModalTemplate, footerFilterPlot } from '../data/htmlTemplates.js';
import { ajustarColorParcelas, ajustarPopupsParcelas, ponerChartPopupParcela } from './plots.js';
import { getLiteral, uriToLiteral, firstUppercase, indexOfNormalized, configurarModal } from './util.js';
import { sendEvent } from './events.js';


//////////////////////////////
// FUNCIONES ÚTILES DE TAXONES
function getMoreSpecificTaxon(types) {
	if (!types)
		return undefined;
	// inicializaciones
	let suri = undefined;
	let nexpuris = null;
	// convierto en array si hace falta
	let arsp = Array.isArray(types)? types : [ types ];
	// evalúo cada uno de los tipos disponibles
	for (let evtype of arsp) {
		if (Datos.taxones[evtype] != undefined && Datos.taxones[evtype].expuris != undefined) {
			// aquí tengo uno válido, miro si es mejor que lo que tenía
			if (nexpuris == null || Datos.taxones[evtype].expuris.length < nexpuris) {
				suri = evtype;
				nexpuris = Datos.taxones[evtype].expuris.length;
			}
		}	
	}
	// devuelvo suri
	return suri;
}

function sumMeasureTaxon(measure, tx) {
	// obtengo medida por taxón
	let sum = 0;
	if (measure) {
		const alltx = Object.keys(measure); // obtengo los taxones de la parcela o provincia
		for (let evtx of alltx) {
			if (tx === config.treeUri) // en caso de árbol genérico, siempre adentro
				sum += measure[evtx];
			else {
				// compruebo si está contenida evtx en la lista de especies expandida de tx
				if (Datos.taxones[tx].expuris.includes(evtx) )
					sum += measure[evtx];
			}	
		}
		// dos decimales
		sum = Number(sum.toFixed(2));
	}
	return sum;
}


////////////////////////////
// HANDLER NOMBRE CIENTÍFICO
function handlerNombreCientifico() {
	// guardo valor (en memoria y en local storage para recordarlo entre sesiones)
	Sesion.nomci = this.checked;
	localStorage.setItem('nomci', Sesion.nomci); // guardará "true" o "false"
	
	// 	nombres científicos o no
	sendEvent( 'select_content', { content_type: 'scientific_names_' + Sesion.nomci } );
	
	// etiquetas filtros de taxón
	visualizarFiltrosTaxon();

	// navegador taxones: cambio las etiquetas de todas las especies en la lista
	document.querySelectorAll("#taxones_block [spuri]").forEach(function(element) {
		// obtengo la especie
		const spuri= element.getAttribute("spuri");
		// nombre vulgar y científico
		const nvul = getTaxonLabel(spuri, false);
		const ncie = getTaxonLabel(spuri, true, true);
		// hago reemplazo en el markup del botón
		const oldmarkup = element.innerHTML;
		const newmarkup = Sesion.nomci ? oldmarkup.replace(nvul, ncie) : oldmarkup.replace(ncie, nvul);
		element.innerHTML = newmarkup;
	});
	
	// entrada taxones: regenero sugerencias con un evento de tipo 'search'
	if (document.getElementById("in_taxon")) {
		const entrada = document.getElementById("in_taxon").value;
		if (entrada.length > 0) {
			const searchEvent = new Event('search', {}); 
			document.getElementById("in_taxon").dispatchEvent(searchEvent);
		}
	}
	
	// en parcelas actualizo los popups
	ajustarPopupsParcelas(Object.keys(Sesion.parPintadas));
}


////////////////////////////////
// VISUALIZACIÓN FILTRO TAXÓN (modo mapa)
// se llama desde cargarURL y desde handlerNombreCientifico
////////////////////////////////
function visualizarFiltrosTaxon() {
	// plantae
	if (Sesion.taxones.length == 0) {
		document.getElementById("lab_plantae").innerHTML = Sesion.nomci? '<i>Plantae</i>' : getLiteral(dict.plants);
		// ajusto el icono para el arranque (no sé lo que hay hasta que no analice SP)
		const iel = document.getElementById("filter-plantae").querySelector('i');		
		if (Sesion.taxonesFiltros[config.treeUri]) {
			iel.classList.remove('bi-filter-circle-fill');
			iel.classList.add('bi-filter-circle');
		}
		else {
			iel.classList.add('bi-filter-circle-fill');
			iel.classList.remove('bi-filter-circle');
		}
		document.getElementById('plantae').classList.remove("d-none");
	} 
	else // escondo plantae
		document.getElementById('plantae').classList.add("d-none");

	// borro todos los filtros de taxón
	document.querySelectorAll('.div_filtro_taxon').forEach(function(div) {
		div.remove();
	});
	
	// ajusto taxones_resumen
	if (Sesion.taxones.length == 0)// || (Object.keys(Sesion.estado.SP.provs).length == 0 && Sesion.estado.SP.polis.length == 0))
		document.getElementById('taxones_resumen').classList.add('d-none'); // escondo
	else {
		document.getElementById('taxones_resumen').classList.remove('d-none'); // muestro
		// muestro/escondo el botón AND/OR y el mensajito de ayuda
		//if (Sesion.taxones.length == 1) {
		if ((new Set(Sesion.taxones)).size == 1) { // utilizo el Set para evitar repeticiones
			document.getElementById('radioandor').classList.add('d-none'); // escondo
			document.getElementById('textfiltered').classList.add('d-none'); // escondo
		}
		else {
			document.getElementById('radioandor').classList.remove('d-none'); // muestro
			const mensaje = Sesion.taxonAnd? getLiteral(dict.filteringAND) : getLiteral(dict.filteringOR);
			document.getElementById('textfiltered').innerHTML = mensaje;
			document.getElementById('textfiltered').classList.remove('d-none'); // muestro
		}
	}	
	
	// si hay filtros de taxón los muestro
	if (Sesion.taxones.length > 0) { // escondo el contenido		
		// preparo array con taxones filtrados
		let txfilts = [];
		const colsactivos = Sesion.taxonesColores.slice(0, Sesion.taxones.length);
		for (let ind=0; ind<Sesion.taxones.length; ind++) {
			const tx = Sesion.taxones[ind];
			// IMPORTANTE: compruebo si es el primero (si no lo es, no lo mostramos)
			if (Sesion.taxones.indexOf(tx) != ind)
				continue;			
			const label = getTaxonLabel(tx, Sesion.nomci, true);
			// incluyo colores posibles
			let colores = [];
			const colsno = colsactivos.filter(c => c !== Sesion.taxonesColores[ind]);
			const cols = config.coltxinds.filter(c => !colsno.includes(c));
			for (let cind of cols)
				colores.push( {"cind": cind, "label": getLiteral(dict["color"+cind])} );
			const txobj = {
				ind: ind,
				turi: tx,
				textoFiltroTaxon: label, //getLiteral(dict.filtering) +' <strong>' + label + '</strong>',
				color: config.colores[Sesion.taxonesColores[ind]][1],
				colores: colores,
				info: Datos.taxones[tx].wikidata? true : false,
				filterUnset: !Sesion.taxonesFiltros[tx] // nuevo
			};
			txfilts.push(txobj);
		}
		// preparo el contenido
		const content = Mustache.render(filtroTaxonesTemplate, txfilts);
		// lo adjunto
		document.getElementById('div-taxons-heading').insertAdjacentHTML('beforeend', content);
		
		// pongo handlers
		// ajustar filtro de taxón a las parcelas
		document.querySelectorAll('.tune_filter_taxon').forEach(el => {
			el.addEventListener('click', handlerAjustarFiltroTaxon);
		});
		// quitar filtro de taxón
		document.querySelectorAll('.quitar_taxon').forEach(el => {
			el.addEventListener('click', function () {
				// cojo el taxón y el índice
				const ind = Number(this.getAttribute('ind'));
				const tx = Sesion.taxones[ind];					
				
				// mando evento de quitar filtro de taxón a GA
				sendEvent( 'deselect_content', { content_type: 'taxon_filter', content_id: Sesion.taxones[ind] } );
				
				// si tx está varias veces hay que borrarlo en todas (cojo los índices de mayor a menor)
				const indsborrar = [];
				for (let i=Sesion.taxones.length-1; i>=0; i--) {
					if (Sesion.taxones[i] === tx)
						indsborrar.push(i);
				}
				
				// elimino el filtro de taxón (único)
				delete Sesion.taxonesFiltros[tx];
				
				// elimino los taxones y reajusto colores
				// (al ir de mayor a menor, no hay problema con el splice y los índices)
				for (let ib of indsborrar) {
					// elimino taxón
					Sesion.taxones.splice(ib, 1);
					// reajusto colores
					const col = Sesion.taxonesColores[ib]; // recupero el color
					Sesion.taxonesColores.splice(ib, 1); // lo borro de la posición en que estaba
					Sesion.taxonesColores.splice(Sesion.taxones.length, 0, col); // lo coloco justo después	
				}
				
				// actualizo ediciones del inventario restantes
				for (let ifn of config.ifnVersions)	{
					if (Sesion.estado.ifn !== ifn) {
						for (let ib of indsborrar) {
							// recupero el taxón a borrar
							const txo = Sesion.estado.SP[ifn].tx[ib];
							// si coincide ib con la primera ocurrencia en el array, borro su filtro
							if (ib == Sesion.estado.SP[ifn].tx.indexOf(txo))
								delete Sesion.estado.SP[ifn].txfilt[txo];
							// ahora borro el taxón
							Sesion.estado.SP[ifn].tx.splice(ib, 1);
							// y ahora viene el caso complicado
							if (Sesion.estado.SP[ifn].tx.indexOf(txo) != -1) {
								// aquí puede que haya que reasignar un filtro de taxón
								// (caso en que hay dos taxones en el ifn3 que se mapean al mismo taxón en el ifn2 y se elimina un taxón del ifn3)
								const nind = Sesion.estado.SP[ifn].tx.indexOf(txo);
								if (Sesion.taxonesFiltros[Sesion.taxones[nind]])
									Sesion.estado.SP[ifn].txfilt[txo] = Sesion.taxonesFiltros[Sesion.taxones[nind]];																
							}
						}
					}
				}
						
				// reajusto URL y la cargo
				history.replaceState(Sesion.estado, "", obtenerURL());
				cargarURL();
											
				/* TODO previo
				// cojo el índice
				const ind = Number(this.getAttribute('ind'));						
				// mando evento de quitar filtro de taxón a GA
				sendEvent( 'deselect_content', { content_type: 'taxon_filter', content_id: Sesion.taxones[ind] } );
				
				// quito los ajustes del filtro de taxón en SP
				//(no actualizo Sesion.taxonesFiltros porque es el mismo array que Sesion.estado.SP[Sesion.estado.ifn]).txfilt
				delete Sesion.estado.SP[Sesion.estado.ifn].txfilt[Sesion.taxones[ind]];
				
				// elimino el taxón en SP
				//(no actualizo Sesion.taxones porque es el mismo array que Sesion.estado.SP[Sesion.estado.ifn].tx)
				for (let ifn of config.ifnVersions)		
					Sesion.estado.SP[ifn].tx.splice(ind, 1);
				
				// reajusto colores
				const col = Sesion.taxonesColores[ind]; // recupero el color
				Sesion.taxonesColores.splice(ind, 1); // lo borro de la posición en que estaba
				Sesion.taxonesColores.splice(Sesion.taxones.length, 0, col); // lo coloco justo después		
			
				// reajusto URL y la cargo
				history.replaceState(Sesion.estado, "", obtenerURL());
				cargarURL();*/
			});
		});
		
		// cambio color del filtro de taxón
		document.querySelectorAll('.color_taxon').forEach(el => {
			el.addEventListener('click', function (ev) {
				// si no pongo esto irá a cargarURL (!)
				ev.preventDefault();				
				// cojo el índice
				const mind = Number(this.getAttribute('ind'));
				// cojo el índice del color
				const cind = Number(this.getAttribute('cind'));
				// reajusto colores
				Sesion.taxonesColores[mind] = cind;
				// cambio el color del filtro de taxón
				this.closest('.div_filtro_taxon').querySelector('span').style.backgroundColor = config.colores[cind][1];					
				// actualizo colores parcelas			
				const puris = Object.keys(Sesion.parPintadas);
				ajustarColorParcelas(puris);
				// actualizo popup de parcela si está abierto
				if (Sesion.popup && Sesion.popup.isOpen()) {
					const popel = Sesion.popup.getElement();
					const popupel = popel.querySelector(".popup");
					if (popupel && popupel.classList.contains("parcela")) {
						const piri = popel.querySelector(".popup").getAttribute("iri");
						const latlng = Sesion.popup.getLatLng();
						// cierro y reabro						
						Sesion.popup.close();
						if (Array.isArray(Sesion.parPintadas[piri]))
							Sesion.parPintadas[piri][0].openPopup(latlng);
						else 
							Sesion.parPintadas[piri].openPopup(latlng);
					}
				}								
				// actualizo colores posibles
				const colsactivos = Sesion.taxonesColores.slice(0, Sesion.taxones.length);
				for (let ind=0; ind<Sesion.taxones.length; ind++) {
					const ulColores = document.getElementById("ul_colores" + ind);
					const colsno = colsactivos.filter(c => c !== Sesion.taxonesColores[ind]);
					const cols = config.coltxinds.filter(c => !colsno.includes(c));
                    for (let i = 0; i < cols.length; i++) {
                        const cind = cols[i];
                        // preparo etiqueta
                        const clab = getLiteral(dict['color' + cind]);
                        // obtengo el anchor a actualizar
                        const mia = ulColores.querySelector("li:nth-child(" + (i + 1) + ") a");
                        // actualizo cind y la etiqueta
                        mia.setAttribute('cind', cind);
                        mia.innerHTML = clab;
                    }
				}
			});
		});
	}	
	// info taxón (de Wikidata)
	document.querySelectorAll('.info_taxon').forEach(el => {
		el.addEventListener('click', mostrarInfoTaxon);
	});
}
function mostrarInfoTaxon() {
	// obtengo uri del taxón
	const turi = this.getAttribute("turi");

	// objeto taxón
	const taxon = Datos.taxones[turi];
	// preparo objeto del popover
	let popobj = {};
	/* PREVIO
	// imagen
	if (taxon.wikidata.image) {
		popobj.hayimagen = true;
		const imgsaux = Array.isArray(taxon.wikidata.image)? taxon.wikidata.image : [ taxon.wikidata.image ];
		popobj.image = imgsaux.map((img, index) => {
			// ajusto tamaño para que tarde menos en recuperarla
			const imgsrc = img.startsWith('http://commons.wikimedia.org/wiki/Special:FilePath') && img.indexOf('?') === -1
				? img + "?width=300"
				: img;
			return { src: imgsrc, active: index === 0 };
		});
		if (popobj.image.length == 1)
			popobj.image = popobj.image[0].src;
		else
			popobj.multimages = true;
	}
	// resumen
	if (taxon.wikidata.comment)
		popobj.resumen = getLiteral(taxon.wikidata.comment);
	// wikidataPage
	if (taxon.wikidata)
		popobj.wikidataPage = taxon.wikidata.iri;
	// wikipediaPage
	if (taxon.wikidata && taxon.wikidata.wikipediaPage)
		popobj.wikipediaPage = taxon.wikidata.wikipediaPage;
	// wikispeciesPage
	if (taxon.wikidata && taxon.wikidata.wikispeciesPage)
		popobj.wikispeciesPage = taxon.wikidata.wikispeciesPage;
	// gbifPage
	if (taxon.wikidata && taxon.wikidata.gbifPage)
		popobj.gbifPage = taxon.wikidata.gbifPage;*/
		
	// imagen
	if (taxon.images.length > 0) {
		popobj.hayimagen = true;
		if (taxon.images.length == 1)
			popobj.image = taxon.images[0];
		else {
			popobj.multimages = true;			
			const randomIndex = Math.floor(Math.random() * taxon.images.length);
			popobj.image = taxon.images.map((img, index) => {
				return { src: img, active: index === randomIndex };
			});
		}
	}
	// resumen
	if (taxon.extract)
		popobj.resumen = getLiteral(taxon.extract);
	// wikidataPage
	if (taxon.wikidata)
		popobj.wikidataPage = taxon.wikidata;
	// wikipediaPage
	if (taxon.wikipedia)
		popobj.wikipediaPage = getLiteral(taxon.wikipedia);
	// wikispeciesPage
	if (taxon.wikispecies)
		popobj.wikispeciesPage = taxon.wikispecies;
	// gbifPage
	if (taxon.gbif)
		popobj.gbifPage = taxon.gbif;
		
	// indico tipo: especie, género, familia, clase o agrupación de taxones
	if (taxon.isClass)
		popobj.tipo = getLiteral(dict.class);
	else if (taxon.isFamily)
		popobj.tipo = getLiteral(dict.family);
	else if (taxon.isGenus)
		popobj.tipo = getLiteral(dict.genus);
	else if (taxon.isSpecies)
		popobj.tipo = getLiteral(dict.species);
	else if (taxon.isTaxonSet)
		popobj.tipo = getLiteral(dict.taxonSet);

	// preparo contenido modal
	let tit = getTaxonLabel(turi, true, true);
	//let tit = '<i>' + popobj.nomci + '</i>';				
	let htmlcontent = Mustache.render(taxonModalTemplate, popobj);
	configurarModal( { lg: true, nofooter: true }, 
		tit, htmlcontent, null);
	// muestro modal
	const mimodal = new bootstrap.Modal(document.getElementById('mimodal'));
	mimodal.show();			
	
	// mando evento de info taxón a GA		
	sendEvent( 'select_content', { content_type: 'infoTaxon', content_id: turi } );
}

//////////////////////////
// HANDLER FILTRAR TAXÓN (modo mapa)
function handlerFiltrarTaxon() {
	// obtengo nuevo estado del botón
	const activar = !document.getElementById("bot_taxones").classList.contains("active");
	
	// pongo el botón activo o no
	if (activar)
		document.getElementById("bot_taxones").classList.add("active");
	else 
		document.getElementById("bot_taxones").classList.remove("active");
	
	// render de la selección de taxón
	renderSeleccionTaxon(activar);
}

//////////////////////////
// RENDER SELECCIÓN TAXÓN
function renderSeleccionTaxon(activar) {
	// BLOQUEO/DESBLOQUEO DEL RADIO DE LOS IFNs (lista de taxones se actualizará)
	for (let ifn of config.ifnVersions) {
    	const elifn = document.getElementById(ifn);
	    if (elifn)
			elifn.disabled = activar;
	}
	
	// selecciono los divs apropiados según el modo
	const divbus = document.getElementById("taxones_subheading");
	const divnav = document.getElementById("taxones_block");

	// BÚSQUEDA CON ENTRADA DE TEXTO Y SUGERENCIAS DE TAXONES
	if (activar) {
		// rendering del subheading
		const content = Mustache.render(taxonesSubheadingTemplate, {'activar': activar} );
		divbus.innerHTML = content;
		divbus.classList.remove("d-none");

		// handler de buscar taxon...
		document.getElementById("in_taxon").addEventListener('keyup', handleTaxonInput);
		document.getElementById("in_taxon").addEventListener('search', handleTaxonInput);
		function handleTaxonInput(e) {
			// Get the suggestions container
		    const sugecont = document.getElementById('sugetaxones');
			//console.log("Caracter: " + e.which);
			// trato las teclas de arriba, abajo y enter			
			if (e.which == 13) { // tecla ENTER
				// array de sugerencias
				const enabledsuges = Array.from(sugecont.children).filter(child => !child.disabled);
				// actúo según el focus
				if (Sesion.txfocus == -1)	{ // ninguna sugerencia seleccionada
					// si hay al menos una sugerencia (y habilitada) voy a la primera
					if (enabledsuges.length > 0)
						enabledsuges[0].click();
				}
				else // obtengo la sugerencia y vamos a ella
					enabledsuges[Sesion.txfocus].click();
			}
			else if (e.which == 40) { // tecla ABAJO
				// incremento focus
				Sesion.txfocus++;
				ajustarTaxonfocus();
			}
			else if (e.which == 38) { // tecla ARRIBA
				// decremento focus
				Sesion.txfocus--;
				ajustarTaxonfocus();
			}
			else { // caso normal
				const entrada = document.getElementById("in_taxon").value;
				// analizo la cadena de entrada
				if (entrada.length < 1) { // está vacía: muestro la taxonomía y elimino las sugerencias
					divnav.classList.remove("d-none");
					document.getElementById("sugetaxones").classList.add("d-none"); // escondo
					sugecont.innerHTML = "";
				}
				else {	// hay algo: muestro sugerencias y escondo la taxonomía
					divnav.classList.add("d-none");
					// obtengo sugerencias de tipos de sitios
					const suges = sugeTaxones(entrada);
					// renderizo las sugerencias
					renderSugeTaxones(entrada, suges);
				}
			}
		}
	} 
	else
		divbus.classList.add("d-none");
	
	// NAVEGACIÓN ONTOLOGÍA DE TIPOS
	if (activar) { // mostrar el bloque de contenido de las especies
		divnav.classList.remove("d-none");
		// ¿caso inicial?
		if (divnav.innerHTML === "") {
			// preparo datos para mostrar
			let btaxainfo = [];
		
			// analizo los taxones top
			for (const spuri of config.taxonesTop) {
				// obtengo información del objeto para formatear
				let spinfo = getInfoSpecies(spuri);
				// incluyo también el indice
				spinfo.indice = 0;
				spinfo.indentspace = '';
				// añado el objeto SÓLO SI TIENE INDIVIDUOS Y NO ES DE txup23
				if (spinfo.nplots > 0 && !spuri.startsWith(config.prefixes.txup23))
					btaxainfo.push(spinfo);
			}
		
			// Sort by 'label' in descending order
			btaxainfo.sort((a, b) => b.label.localeCompare(a.label));
			// Sort by calculated value in descending order
			btaxainfo.sort((a, b) => b.nplots - a.nplots);
		
			// generate the mark-up
			const content = Mustache.render(taxonesBlockTemplate, btaxainfo);
			
			// pongo el contenido
			divnav.innerHTML = content;

			// HANDLERS
			// handler de seleccionar taxón
			document.querySelectorAll('.bot_sel_taxon').forEach(function(element) {
				element.addEventListener('click', handlerSeleccionarTaxon);
			});
			// handler de expandir taxón
			document.querySelectorAll('.bot_expandir_taxon').forEach(function(element) {
				element.addEventListener('click', handlerExpandTaxon);
			});
			// handler de showmore
			document.querySelectorAll('.showmore').forEach(function(element) {
				element.addEventListener('click', handlerShowmore);
			});
		}
	}
	else // esconder el bloque de contenido de los taxones
		divnav.classList.add("d-none");
}



//////////////////////
// HANDLER SUGERENCIAS
//////////////////////
function sugeTaxones(entrada) {
	let sugerencias = [];
	// sólo actúo si la entrada no es una cadena vacía
	if (entrada.length > 0) {
		// obtengo las uris de los taxones ordenados alfabéticamente
		const txuris = Object.keys(Datos.taxones).sort();
		// evalúo cada especie si vale
		for (let txuri of txuris) {
			// obtengo etiqueta de la especie (según Sesion.nomci)
			const labesp = getTaxonLabel(txuri, Sesion.nomci);
			// si coincide, a las sugerencias
			if (indexOfNormalized(labesp, entrada) > -1)
				sugerencias.push(txuri);
		}
	}
	return sugerencias;
}
function renderSugeTaxones(entrada, sugerencias) {
	// preparo sugerencias
	let sinfo = {};
	sinfo.sugerencias = [];
		
	// obtengo las sugerencias si la entrada no está vacía
	if (sugerencias.length == 0)
		sinfo.nosugerencias = true;
	else {
		for (let suge of sugerencias) {			
			// obtengo información del objeto para formatear
			let spinfo = getInfoSpecies(suge);
			// índice en el que hubo match
			const ind = indexOfNormalized(spinfo.label, entrada);
			// formateo el nombre a mostrar con negritas
			spinfo.labelshown = "";
			if (ind > 0)
				spinfo.labelshown += spinfo.label.substr(0, ind);
			spinfo.labelshown += "<strong>" + spinfo.label.substr(ind, entrada.length) + "</strong>"
			spinfo.labelshown += spinfo.label.substr(ind + entrada.length);			
			// añado el objeto SÓLO SI TIENE PARCELAS Y NO ES DE txup23
			if (spinfo.nplots > 0 && !suge.startsWith(config.prefixes.txup23))
				sinfo.sugerencias.push(spinfo);
		}
	}
	
	// ordeno sugerencias por número de parcelas
	sinfo.sugerencias.sort((a, b) => b.nplots - a.nplots);
	
	// corto número de sugerencias
	sinfo.sugerencias = sinfo.sugerencias.slice(0, config.numsugs);
	
	// muestro sugerencias
	const cont = Mustache.render(sugeTaxonesTemplate, sinfo);
	document.getElementById("sugetaxones").innerHTML = cont;
	document.getElementById("sugetaxones").classList.remove("d-none"); // muestro
			
	// handler de los botones de sugerencias
	document.querySelectorAll('.bot_suge_taxon').forEach(function(element) {
		element.addEventListener('click', handlerSeleccionarTaxon);
	});
	
	// inicializo focus
	Sesion.txfocus = -1;
}
function ajustarTaxonfocus() {
	// Sesion.txfocus = 0; => cajetín entrada
	// Sesion.txfocus = i; => num de sugerencia
	
	// array de sugerencias que no están deshabilitadas
	const enabledsuges = Array.from(document.getElementById('sugetaxones').children).filter(child => !child.disabled);
	
	// obtengo número de sugerencias que no están deshabilitadas
	const ns = enabledsuges.length;
	// reajusto índice del focus si hace falta
	if (ns == 0) Sesion.txfocus = -1;
	else if (Sesion.txfocus >= ns) Sesion.txfocus = 0;
	else if (Sesion.txfocus < 0) Sesion.txfocus = ns -1;
	// y ahora las cosas visuales
	for (const es of enabledsuges) 
		es.classList.remove('active');
	if (Sesion.txfocus >= 0)
		enabledsuges[Sesion.txfocus].classList.add('active');
}


/////////////////////////////
// HANDLER NAVEGACIÓN TAXONES
/////////////////////////////
function handlerExpandTaxon(event) {
    const icon = event.currentTarget.querySelector("i");
    const div = event.currentTarget.closest(".taxon");

    if (event.currentTarget.classList.contains("active")) { // colapsar
        // desactivo botón
        event.currentTarget.classList.remove("active");
        // cambio el icono
        icon.classList.remove("bi-chevron-down");
        icon.classList.add("bi-chevron-right");

        // itero para quitar los elementos de la lista
        const indice = +div.getAttribute("indice");
        let nextDiv = div.nextElementSibling;
        while (nextDiv && +nextDiv.getAttribute("indice") > indice) {
            const temp = nextDiv.nextElementSibling;
            nextDiv.remove();
            nextDiv = temp;
        }
    } 
    else { // expandir
        // activo botón
        event.currentTarget.classList.add("active");
        // cambio el icono
        icon.classList.remove("bi-chevron-right");
        icon.classList.add("bi-chevron-down");

        // obtengo URI de la clase y preparo el indent
        const spuri = div.querySelector(".bot_sel_taxon").getAttribute("spuri");
        const newIndice = +div.getAttribute("indice") + 1;
        let indentSpace = "&nbsp;".repeat(newIndice * 4);

        // generar objeto auxiliar para la plantilla
        let scobj = [];
        for (let subspuri of Datos.taxones[spuri].subclasses) {
        	// obtengo información del objeto para formatear
            let subspinfo = getInfoSpecies(subspuri);
			// incluyo también el indent
            subspinfo.indice = newIndice;
            subspinfo.indentspace = indentSpace;
			// añado el objeto SÓLO SI TIENE PARCELAS Y NO ES DE txup23
            if (subspinfo.nplots > 0 && !subspuri.startsWith(config.prefixes.txup23))
                scobj.push(subspinfo);
        }

        // sort elements
        scobj.sort((a, b) => a.label.localeCompare(b.label));
        scobj.sort((a, b) => b.nplots -a.nplots);

        // show more button
        if (scobj.length > config.hidemax) {
            scobj.splice(config.hidebegin, 0, { "botonesconder": true, "indice": newIndice, "indentspace": indentSpace + "&nbsp;&nbsp;&nbsp;&nbsp;" });
            for (let ind = config.hidebegin + 1; ind < scobj.length; ind++)
                scobj[ind].esconder = true;
        }

        // generate content and add to the DOM
        const newContent = Mustache.render(taxonesBlockTemplate, scobj);
        div.insertAdjacentHTML('afterend', newContent);

        // handler de seleccionar taxón
        document.querySelectorAll(".bot_sel_taxon").forEach(button => {
            button.removeEventListener('click', handlerSeleccionarTaxon);
            button.addEventListener('click', handlerSeleccionarTaxon);
        });
		
		// recreate handlers of the expand/collapse buttons
        document.querySelectorAll(".bot_expandir_taxon").forEach(button => {
            button.removeEventListener('click', handlerExpandTaxon);
            button.addEventListener('click', handlerExpandTaxon);
        });

		// recreate handlers of the showmore buttons
        document.querySelectorAll(".showmore").forEach(button => {
            button.addEventListener('click', handlerShowmore);
        });
    }
}
function handlerShowmore(event) {
    const div = event.currentTarget.closest(".taxon");
    const indice = +div.getAttribute("indice");
	// show elements
    let aux = div.nextElementSibling;
    while (aux && +aux.getAttribute("indice") === indice && aux.classList.contains("d-none")) {
        aux.classList.remove("d-none");
        aux.classList.add("d-flex");
        aux = aux.nextElementSibling;
    }
    // remove show more button
    div.remove();
}


// para formatear las especies (ahora tengo en cuenta versión inventario)
function getInfoSpecies(spuri) {
	// recupero especie
	const sp = Datos.taxones[spuri];	
	// el objeto a devolver
	let spinfo = {};
	// incluyo la uri
	spinfo.uri = spuri;
	// etiqueta especie
	spinfo.label = getTaxonLabel(spuri, Sesion.nomci);
	spinfo.nc = Sesion.nomci;
	// info número de clases SÓLO SI TIENE PARCELAS Y NO ES DE txup23
	spinfo.nclasses = 0;
	for (let suburi of Datos.taxones[spuri].subclasses) {
		if (Datos.taxones[suburi] && Datos.taxones[suburi].nplots[Sesion.estado.ifn].count > 0
				&& !suburi.startsWith(config.prefixes.txup23))
			spinfo.nclasses++;
	}
	if (spinfo.nclasses == 0)
		spinfo.nosubclasses = true;
	// info parcelas
	spinfo.nplots = sp.nplots[Sesion.estado.ifn].count;
	if (spinfo.nplots > 1000000)
		spinfo.nplotslab = "+" + Math.floor(+spinfo.nplots/1000000) + "M";
	else if (spinfo.nplots > 1000)
		spinfo.nplotslab = "+" + Math.floor(+spinfo.nplots/1000) + "K";
	else
		spinfo.nplotslab = spinfo.nplots;
	// devuelvo el objeto
	return spinfo;
}



//////////////////////////
// HANDLER SELECCIÓN TAXÓN
//////////////////////////
function handlerSeleccionarTaxon(event) {
	// obtengo uri del taxon
	const turi = event.currentTarget.getAttribute("spuri");
	console.log(turi);
	
	// vamos a la selección del taxón
	tratarSeleccionTaxon(turi);
	
	// click en botón de seleccionar taxón para cerrar el panel correspondiente
	const bot = document.getElementById("bot_taxones");
	bot.click();
}
function tratarSeleccionTaxon(turi) {
	// compruebo si la tenía
	if (!Sesion.taxones.includes(turi)) { // no estaba
		// si supero el número de especies filtradas no permito filtrar más
		if (Sesion.taxones.length >= config.maxTaxonFilters) {
			// aviso con un toast de que hay muchos taxones...
			document.getElementById("mitostadaStrong").innerHTML = getLiteral(dict.title);
			document.getElementById("mitostadaBody").innerHTML = getLiteral(dict.tooManyTaxons);
			const tostada = bootstrap.Toast.getOrCreateInstance(document.getElementById('mitostada'));
			tostada.show();
		}
		else { // a guardar				
			// mando evento de filtro de taxón a GA		
			sendEvent( 'select_content', { content_type: 'taxon_filter', content_id: turi } );
			
			// guardo taxones de SP (no actualizo Sesion.taxones porque es el mismo array que Sesion.estado.SP[Sesion.estado.ifn])
			for (const ifn of config.ifnVersions) {
				if (Sesion.estado.ifn === ifn)
					Sesion.estado.SP[ifn].tx.push(turi); // lo guardo tal cual
				else { // hay que hacer mapeos entre inventarios
					const txmap = correspondenciaTaxon(turi, ifn);
					Sesion.estado.SP[ifn].tx.push(txmap);
				}
			}
			// reajusto URL
			history.replaceState(Sesion.estado, "", obtenerURL());
			// cargo la URL
			cargarURL();
		}
	}
	else {	// si estaba pongo otro toast
		document.getElementById("mitostadaStrong").innerHTML = getLiteral(dict.title);
		document.getElementById("mitostadaBody").innerHTML = getLiteral(dict.taxonAlreadyIncluded);
		const tostada = bootstrap.Toast.getOrCreateInstance(document.getElementById('mitostada'));
		tostada.show();
	}
}


//////////////////////////////
// HANDLER AJUSTE FILTRO TAXÓN
//////////////////////////////
function handlerAjustarFiltroTaxon() {
	// defino slids
	const slids = [	"nt", "ba", "vwb", "vwob" ];
	//const slids = [	"numberTreesHa", "basalAreaM2byHa", "volumeWithBarkM3byHa", "volumeWithoutBarkM3byHa", "sampledTrees" ];
	// referencia al iel para actualizar el icono luego...
	const iel = this.querySelector('i');
	// recupero el taxón (treeUri en este caso)
	const tx = this.getAttribute('turi')
	// recupero el filtro (si lo hay)
	let txfilt = Sesion.taxonesFiltros[tx];
	// configuro modal
	let txlab = Sesion.nomci? '<i>Plantae</i>' : getLiteral(dict.plants);
	if (tx !== config.treeUri)
		txlab = getTaxonLabel(tx, Sesion.nomci, true);
	const txobj = { txname: txlab };
	// para cada slid...
	for (const slid of slids) {
		txobj[slid+'min'] = txfilt && txfilt[slid]? txfilt[slid].min : 0;
		txobj[slid+'max'] = txfilt && txfilt[slid]? txfilt[slid].max : config.maxValuesPlot[slid];
	}
	// preparo cadenas
	txobj.numbertreesHA = getLiteral(dict.numbertreesHA);
	txobj.basalareaHA = window.innerWidth < 600? getLiteral(dict.basalareaHAmini) : getLiteral(dict.basalareaHA);
	txobj.volumewithbarkHA = window.innerWidth < 600? getLiteral(dict.volumewithbarkHAmini) : getLiteral(dict.volumewithbarkHA);
	txobj.volumewithoutbarkHA = window.innerWidth < 600? getLiteral(dict.volumewithoutbarkHAmini) : getLiteral(dict.volumewithoutbarkHA);
	// obtengo body del modal
	const modalbody = Mustache.render(filterPlotModalTemplate, txobj);
	configurarModal( { lg: false }, 
		getLiteral(dict.plotfilter), modalbody, footerFilterPlot);
	// muestro modal
	const mimodal = new bootstrap.Modal(document.getElementById('mimodal'));
	mimodal.show();			
	// creo sliders
	for (const slid of slids) {
		const slel = document.getElementById(slid);
		noUiSlider.create(slel, {
			start: [ txobj[slid+'min'], txobj[slid+'max']],
			step: 1,
			connect: true,
			range: {
				'min': 0,
				'max': config.maxValuesPlot[slid]
			}
		});
		// actualizo inputs
		slel.noUiSlider.on('update', function (values, handle) {
			const vmin = Math.round(values[0]);
			const vmax = Math.round(values[1]);
			document.getElementById(slid+'-min').value = vmin;
			document.getElementById(slid+'-max').value = vmax;
		});
		// listener min
		document.getElementById(slid+'-min').addEventListener('change', function(event) {
			const val = event.target.value;
			if (val === "") // entrada extraña, recupero valor anterior
				this.value = Math.round(slel.noUiSlider.get()[0]);
			else // actualización slider
				slel.noUiSlider.set([val, null]);
		});
		// listener max
		document.getElementById(slid+'-max').addEventListener('change', function(event) {
			const val = event.target.value;
			if (val === "") // entrada extraña, recupero valor anterior
				this.value = Math.round(slel.noUiSlider.get()[1]);
			else // actualización slider
				slel.noUiSlider.set([null, val]);
		});
	}
	// listener	al botón de aplicar filtro
	document.getElementById('applyFilter').addEventListener('click', function() {
		// preparo filtro
		txfilt = {};
		let hayalgo = false;
		// reviso uno a uno los sliders
		for (const slid of slids) {
			const slel = document.getElementById(slid);
			const values = slel.noUiSlider.get();
			if (Math.round(values[0]) != 0 || Math.round(values[1]) != config.maxValuesPlot[slid]) {
				txfilt[slid] = {
					'min': Math.round(values[0]),
					'max': Math.round(values[1])
				};
				hayalgo = true;
			}
		}
		// guardo o borro el filtro y ajusto el icono de filtrar
		const txindor = Sesion.taxones.indexOf(tx);
		if (hayalgo) {
			Sesion.taxonesFiltros[tx] = txfilt;
			iel.classList.remove('bi-filter-circle-fill');
			iel.classList.add('bi-filter-circle');
			// aplico el mismo filtro para el resto de inventarios
			for (const ifn of config.ifnVersions) {
				if (Sesion.estado.ifn !== ifn) {
					let txotro = config.treeUri;
					if (tx !== config.treeUri) {
						// hay que buscar la coincidencia
						txotro = Sesion.estado.SP[ifn].tx[txindor];
						// IMPORTANTE: por los mapeos puede que se repita un taxón
						// en ese caso sólo se actualiza si txindor coincide 
						// con el índice de la primera repetición en el otro inventario
						const txindotro = Sesion.estado.SP[ifn].tx.indexOf(txotro);
						if (txindor != txindotro)
							txotro = null;
					}
					// aplico el mismo filtro
					if (txotro)
						Sesion.estado.SP[ifn].txfilt[txotro] = txfilt;
				}
			}
		}
		else {
			delete Sesion.taxonesFiltros[tx];
			iel.classList.add('bi-filter-circle-fill');
			iel.classList.remove('bi-filter-circle');
			// quito el filtro para el resto de inventarios
			for (const ifn of config.ifnVersions) {
				if (Sesion.estado.ifn !== ifn) {
					let txotro = config.treeUri;
					if (tx !== config.treeUri) {
						// hay que buscar la coincidencia
						txotro = Sesion.estado.SP[ifn].tx[txindor];
						// IMPORTANTE: por los mapeos puede que se repita un taxón
						// en ese caso sólo se actualiza si txindor coincide 
						// con el índice de la primera repetición en el otro inventario
						const txindotro = Sesion.estado.SP[ifn].tx.indexOf(txotro);
						if (txindor != txindotro)
							txotro = null;
					}
					// quito el filtro
					if (txotro)
						delete Sesion.estado.SP[ifn].txfilt[txotro];
				}
			}
		}
		
		// mando evento GA
		sendEvent( 'select_content', { content_type: 'apply_filter', content_id: tx, set: hayalgo } );
		
		// reajusto URL y la cargo
		history.replaceState(Sesion.estado, "", obtenerURL());
		cargarURL();
	});
	// listener	al botón de resetear filtro
	document.getElementById('resetFilter').addEventListener('click', function() {
		// borro el filtro y ajusto el icono de filtrar
		delete Sesion.taxonesFiltros[tx];
		iel.classList.add('bi-filter-circle-fill');
		iel.classList.remove('bi-filter-circle');
		// quito el filtro para el resto de inventarios
		const txindor = Sesion.taxones.indexOf(tx);
		for (const ifn of config.ifnVersions) {
			if (Sesion.estado.ifn !== ifn) {
				let txotro = config.treeUri;
				if (tx !== config.treeUri) {
					// hay que buscar la coincidencia
					txotro = Sesion.estado.SP[ifn].tx[txindor];
					// IMPORTANTE: por los mapeos puede que se repita un taxón
					// en ese caso sólo se actualiza si txindor coincide 
					// con el índice de la primera repetición en el otro inventario
					const txindotro = Sesion.estado.SP[ifn].tx.indexOf(txotro);
					if (txindor != txindotro)
						txotro = null;				
				}
				// quito el filtro 
				if (txotro)
					delete Sesion.estado.SP[ifn].txfilt[txotro];
			}
		}
		
		// mando evento GA
		sendEvent( 'select_content', { content_type: 'reset_filter', content_id: tx } );
		
		// reajusto URL y la cargo
		history.replaceState(Sesion.estado, "", obtenerURL());
		cargarURL();
	});
}


///////////////////////////////////////////////////
// USO ONTOLOGÍA UP23 PARA EXTRAER CORRESPONDENCIAS
///////////////////////////////////////////////////
// se usa en cargarURL para mapear un taxón de un ifn a otro ifnobj
function correspondenciaTaxon(turi, ifnobj) {
	// de momento sólo devuelvo una o null
	if (!Datos.taxones[turi])
		return null;
	// caso trivial, nada que mapear
	if (turi.startsWith(config.prefixes.txtop) || turi.startsWith(config.prefixes["tx"+ifnobj]))
		return turi;
	// hay que hacer mapeo, analizo las superclases y busco taxón txup23
	const txup23 = Datos.taxones[turi].superclasses.find((supuri) => supuri.startsWith(config.prefixes.txup23));
	// si no hay txup23, nada que hacer
	if (!txup23) 
		return null;
	// analizo los mapeos de txup23 para ifnobj
	const txifnobj = Datos.taxones[txup23].subclasses.filter((suburi) => suburi.startsWith(config.prefixes["tx"+ifnobj]));
	if (txifnobj.length == 0) // sin mapeos
		return null;
	else if (txifnobj.length == 1) // mapeo 1-1, lo devuelvo
		return txifnobj[0];
	else {
		// caso complicado, se mapea a varios taxones
		// devuelvo el primer taxón padre de tipo txtop de txup23
		return Datos.taxones[txup23].superclasses.find((supuri) => supuri.startsWith(config.prefixes.txtop));
	}	
}


function getTaxonLabel(turi, nomci, incluiri) {
	let txlab = uriToLiteral(turi);
	if (Datos.taxones[turi]) {
		txlab = firstUppercase(getLiteral(Datos.taxones[turi].vulgarName, txlab));
		if (nomci) {
			txlab = firstUppercase(getLiteral(Datos.taxones[turi].scientificName, txlab));
			if (incluiri)
				txlab =  '<i>' + txlab + '</i>';
		}
	}
	return txlab;
}

export { getMoreSpecificTaxon, sumMeasureTaxon, handlerNombreCientifico, handlerFiltrarTaxon, handlerAjustarFiltroTaxon,
	visualizarFiltrosTaxon, correspondenciaTaxon, getTaxonLabel };